module.exports = __webpack_public_path__ + "static/media/i1.a132014c.png";